import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Header from '../../components/Header'
import SelectEnterprise from '../../components/SelectEnterprise'
import UserApi from '../../api/user/user'

import {
  MailOutline,
  PeopleOutline,
  Campaign,
  Description,
  EmojiEvents,
  Person,
} from '@mui/icons-material'

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

const modules = [
  { title: 'Atendimento',           url: '/mensagens',   icon: <MailOutline fontSize="medium" /> },
  { title: 'Proprietários',         url: '/proprietarios', icon: <PeopleOutline fontSize="medium" /> },
  { title: 'Comunicados',           url: '/comunicados', icon: <Campaign fontSize="medium" /> },
  { title: 'Documentos',            url: '/arquivos',    icon: <Description fontSize="medium" /> },
  { title: 'Programa de fidelidade',url: '/Pontos',      icon: <EmojiEvents fontSize="medium" /> },
  { title: 'Gestão de usuários',    url: '/gestao-usuarios', icon: <Person fontSize="medium" /> },
]

const actions = modules.map((m) => ({
  title: m.title,
  href: m.url,
  icon: m.icon,
  iconForeground: 'text-white',
  iconBackground: 'bg-[#F28E00]',
  description: `Acesse o módulo ${m.title} para gerenciar suas funções.`,
}))

const Home: React.FC = () => {
  const [selectActive, setSelectActive] = useState<number | null>(null)
  const [userName, setUserName]         = useState<string>('')

  useEffect(() => {
    UserApi.listUserData()
      .then(r => r?.Name && setUserName(r.Name))
      .catch(console.error)
  }, [])

  useEffect(() => {
    const id = localStorage.getItem('selectedNetwork')
    if (id) setSelectActive(Number(id))
  }, [])

  const handleSelectedHotelChange = (id: number | null) => {
    if (selectActive !== id) setSelectActive(id)
  }

  return (
    <div className="p-8">
      <div className="flex w-full mb-8">
        <div className="w-1/2">
          <Header
            title={`Bem-vindo${userName ? `, ${userName}` : ''}!`}
            subTitle="Esta é a home do painel administrativo."
            arrowIcon={false}
          />
        </div>
        <div className="flex flex-col items-end gap-5 w-1/2">
          <SelectEnterprise onSelectedHotelChange={handleSelectedHotelChange} />
        </div>
      </div>

      <section>
        <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-200 shadow-sm sm:grid sm:grid-cols-2 sm:gap-px sm:divide-y-0">
          {actions.map((action, idx) => (
            <div
              key={action.title}
              className={classNames(
                idx === 0 ? 'rounded-tl-lg rounded-tr-lg sm:rounded-tr-none' : '',
                idx === 1 ? 'sm:rounded-tr-lg' : '',
                idx === actions.length - 2 ? 'sm:rounded-bl-lg' : '',
                idx === actions.length - 1 ? 'rounded-br-lg rounded-bl-lg sm:rounded-bl-none' : '',
                'group relative bg-white p-6 focus-within:ring-2 focus-within:ring-[#2E406B] focus-within:ring-inset'
              )}
            >
              <div>
                <span
                  className={classNames(
                    action.iconBackground,
                    action.iconForeground,
                    'inline-flex rounded-lg p-3 ring-4 ring-white'
                  )}
                >
                  {action.icon}
                </span>
              </div>
              <div className="mt-8">
                <h3>
                  <Link
                    to={action.href}
                    className="relative block focus:outline-none text-base font-bold text-[#2E406B] hover:text-blue-800"
                  >
                    <span aria-hidden="true" className="absolute inset-0" />
                    {action.title}
                  </Link>
                </h3>
                <p className="mt-2 text-sm text-gray-500">{action.description}</p>
              </div>
              <span
                aria-hidden="true"
                className="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
              >
                <svg fill="currentColor" viewBox="0 0 24 24" className="h-6 w-6">
                  <path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" />
                </svg>
              </span>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Home
